module.exports = __webpack_public_path__ + "static/media/clothes_fulltime.e8ea401d.png";